export const setTechnicianOptions = ({ columns, data }) => {
  const techAccessor = columns.findIndex((c) => c.accessor === 'technician');

  data.forEach((d) => {
    const technicianIndex = columns[techAccessor].options.findIndex(
      (x) => x.id === d.id,
    );

    if (technicianIndex === -1)
      columns[techAccessor].options.push({
        id: d.id,
        value: d.id,
        label: `${d.firstName} ${d.lastName}`,
        firstName: d.firstName,
        lastName: d.lastName,
        isActive: d.isActive,
        selected: true,
      });
  });

  return columns;
};
